var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 70,
    viewBox: "0 0 40 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_26643_10239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.71429 13.9671V11.515C3.71429 9.17899 5.81875 7.30761 8.41328 7.30761L34.301 7.30761C36.8955 7.30761 39 9.17899 39 11.515V13.9671L38.8414 17.3743L37.7604 40.0114L37.6162 43.1218C37.6018 43.4831 37.573 43.8445 37.5298 44.2059C37.4289 45.6513 37.1982 47.071 36.8811 48.4907C36.8523 48.6197 36.8235 48.7359 36.7802 48.8649L35.9154 54.1177C35.3244 57.6539 31.8794 60.2738 27.8291 60.2738H26.2291C26.157 60.7772 25.6814 61.1644 25.076 61.1644H24.9895V63.9392C24.9895 65.7976 23.3175 67.3076 21.2418 67.3076C20.1896 67.3076 19.2527 66.9333 18.5752 66.3139C17.8978 65.7073 17.4798 64.8684 17.4798 63.9392V61.1515C16.9176 61.1256 16.4708 60.7643 16.3843 60.2738H14.7699C10.6475 60.2738 7.17367 57.5765 6.66918 53.9757L5.68902 47.0581L5.66019 46.9032C5.42957 45.7417 5.27101 44.5672 5.17011 43.3928C5.14128 43.0831 5.12687 42.7604 5.11245 42.4507L4.99714 40.0114L3.88726 17.3743L3.71429 13.9671Z",
    fill: "#B2B9C4"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26643_10239)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.87 66.8267C17.8088 66.8267 16.1223 65.234 16.1223 63.2739L16.1223 57.9243H23.6465L23.6465 63.2739C23.6321 65.234 21.9456 66.8267 19.87 66.8267Z",
    fill: "#2C2C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8715 63.6958C18.4301 63.6958 17.277 62.5932 17.277 61.2456V59.3808H22.4805V61.2456C22.4805 62.6068 21.3129 63.6958 19.8859 63.6958H19.8715Z",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8696 62.3345C18.4282 62.3345 17.275 61.2319 17.275 59.8843V58.0194H22.4785V59.8843C22.4785 61.2455 21.311 62.3345 19.884 62.3345H19.8696Z",
    fill: "url(#paint0_radial_26643_10239)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7192 60.3472H16.1806C15.532 60.3472 14.9986 59.8435 14.9986 59.231V57.9106H24.8867V59.231C24.8867 59.8435 24.3534 60.3472 23.7048 60.3472H23.7192Z",
    fill: "#646464"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35687 10.4043V7.99495C2.35687 5.53115 4.46132 3.55739 7.05586 3.55739L32.9436 3.55739C35.5381 3.55739 37.6426 5.53115 37.6426 7.99495V10.4043C37.6426 8.22635 35.7832 6.44316 33.4481 6.44316L6.56578 6.44316C4.2307 6.44316 2.35687 8.22635 2.35687 10.4043Z",
    fill: "#686868"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33066 45.483L4.59012 46.8443C5.15227 49.7709 7.97743 51.9216 11.3071 51.9216L28.8346 51.9216C30.4634 51.9216 31.9769 51.4043 33.1589 50.5331C34.2399 49.7436 35.0471 48.6547 35.4219 47.3887L34.557 52.9289C33.9661 56.6586 30.5211 59.4219 26.4707 59.4219L13.4115 59.4219C9.28911 59.4219 5.81532 56.5769 5.31082 52.7792L4.33066 45.483Z",
    fill: "url(#paint1_linear_26643_10239)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35687 10.5813V10.4044C2.35687 8.22641 4.2307 6.44322 6.56578 6.44322L33.4481 6.44322C35.7832 6.44322 37.6426 8.22641 37.6426 10.4044V10.5813L37.484 14.1749L36.403 38.0506L36.2588 41.3311C36.2444 41.7123 36.2156 42.0934 36.1723 42.4746C36.0714 43.9991 35.8408 45.4965 35.5237 46.9938C35.4949 47.1299 35.466 47.2524 35.4228 47.3885C35.048 48.6545 34.2409 49.7434 33.1598 50.5329C31.9778 51.4041 30.4644 51.9214 28.8356 51.9214L11.308 51.9214C7.97836 51.9214 5.1532 49.7707 4.59105 46.8441L4.3316 45.4828L4.30277 45.3195C4.07214 44.0944 3.91359 42.8557 3.81269 41.617C3.78386 41.2903 3.76945 40.95 3.75503 40.6233L3.63972 38.0506L2.52983 14.1749L2.35687 10.5813Z",
    fill: "url(#paint2_linear_26643_10239)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.36 51.3148L32.96 6.62264H33.3203L31.7203 51.3148C31.605 51.3554 31.4753 51.2877 31.36 51.3148Z",
    fill: "#E7EAEA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9778 51.8535L27.958 6.62275H28.3184L27.3382 51.8535H26.9778Z",
    fill: "#E7EAEA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6245 51.8535L22.9561 6.62275H23.3164L22.9849 51.8535H22.6245Z",
    fill: "#E7EAEA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9253 6.62275H18.2857L18.6172 51.8535H18.2568L17.9253 6.62275Z",
    fill: "#E7EAEA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9232 6.62275H13.2835L14.2637 51.8535H13.9033L12.9232 6.62275Z",
    fill: "#E7EAEA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92249 6.62238H8.28285L9.88281 51.5688C9.7675 51.5418 9.63777 51.5012 9.52246 51.4605L7.92249 6.62238Z",
    fill: "#E7EAEA"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8359 51.6714L11.3076 51.6714C8.0795 51.6712 5.3733 49.5884 4.83691 46.7974L4.57812 45.4399V45.439L4.54883 45.2759V45.2729C4.32006 44.0577 4.1618 42.828 4.06152 41.5972V41.5952C4.03327 41.2751 4.01936 40.94 4.00488 40.6118L3.88965 38.0396V38.0386L2.7793 14.1636V14.1626L2.60645 10.5688V10.4048C2.60645 8.37831 4.35491 6.69305 6.56543 6.69287L33.4482 6.69287C35.6577 6.69296 37.3926 8.37717 37.3926 10.4048V10.5698L37.2344 14.1636L36.1533 38.0396L36.0088 41.3198V41.3218C36.0017 41.5093 35.9917 41.6968 35.9775 41.8843L35.9238 42.4468L35.9229 42.4585C35.8229 43.9686 35.5945 45.4537 35.2793 46.9419C35.2512 47.0745 35.2242 47.1882 35.1846 47.313L35.1826 47.3179C34.8248 48.5263 34.0539 49.5716 33.0137 50.3315L33.0127 50.3306L33.0117 50.3315C31.8734 51.1706 30.4119 51.6713 28.8359 51.6714Z",
    stroke: "url(#paint3_linear_26643_10239)",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1893 57.9243L14.1894 57.9243C13.4687 57.9243 12.748 57.8563 12.0994 57.7065C12.0994 57.7065 12.085 57.7065 12.0706 57.7065C10.7157 57.3934 9.79315 56.917 9.37514 56.2228C9.1301 55.8417 9.20217 55.5966 9.14451 55.2563C9.14451 55.2427 9.14451 55.2291 9.14451 55.2019C9.17334 54.1674 9.08686 51.4449 11.9985 52.4658C12.3012 52.5747 12.676 52.6292 13.0507 52.6292L17.6921 52.6292H27.1621C27.5369 52.6292 27.9117 52.5747 28.2144 52.4658C31.126 51.4449 31.0395 54.1674 31.0684 55.2019C31.0684 55.2155 31.0684 55.2291 31.0684 55.2563C31.0107 55.5966 31.0684 55.8417 30.8377 56.2228C30.4197 56.917 29.4828 57.3934 28.1423 57.7065C28.1423 57.7065 28.1279 57.7065 28.1135 57.7065C27.4648 57.8563 26.7441 57.9243 26.0234 57.9243H22.2037H22.1893Z",
    fill: "#4C4C4C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.715 52.6283H27.0482L28.9941 57.3246C28.7491 57.404 28.4608 57.4834 28.1725 57.5495C28.1725 57.5627 28.1581 57.5627 28.1581 57.5627C27.4951 57.7083 26.7888 57.7744 26.0681 57.7744H23.8339L21.715 52.6283Z",
    fill: "#636363"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9793 52.6018C12.9793 52.6018 13.0513 52.615 13.0946 52.615H17.7359L18.3413 52.6283L20.4746 57.7744H15.127L12.9793 52.6018Z",
    fill: "#636363"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0234 57.8745L14.1895 57.8745C13.472 57.8745 12.7553 57.8073 12.1113 57.6587V57.6567H12.0781C10.7278 57.3442 9.82448 56.8719 9.41797 56.1968L9.41699 56.1958C9.29902 56.0123 9.25825 55.8624 9.23926 55.7173C9.22965 55.6437 9.22593 55.5712 9.2207 55.4937L9.19434 55.2563V55.2036C9.20159 54.9433 9.202 54.5819 9.24316 54.1997C9.28433 53.8175 9.36616 53.4188 9.53516 53.0854C9.70357 52.7534 9.95768 52.4876 10.3438 52.3647C10.7313 52.2415 11.2597 52.2602 11.9814 52.5132C12.2908 52.6245 12.6718 52.6792 13.0508 52.6792L27.1621 52.6792C27.5411 52.6792 27.9221 52.6245 28.2314 52.5132C28.9532 52.2602 29.4816 52.2415 29.8691 52.3647C30.2552 52.4876 30.5093 52.7534 30.6777 53.0854C30.8467 53.4188 30.9286 53.8175 30.9697 54.1997C31.0108 54.5811 31.0113 54.9415 31.0186 55.2017V55.2563C30.9678 55.5635 31.0042 55.7712 30.8662 56.064L30.7949 56.1968C30.3885 56.8718 29.471 57.3442 28.1348 57.6567H28.1133V57.6548L28.1025 57.6577C27.4583 57.8064 26.7412 57.8745 26.0234 57.8745Z",
    stroke: "#777777",
    strokeWidth: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5264 55.3345C32.3754 55.3649 32.2402 55.3376 32.1191 55.2671C31.8733 55.1238 31.6819 54.8 31.5596 54.4097C31.438 54.0217 31.3879 53.5792 31.415 53.2134C31.4286 53.0305 31.4615 52.8688 31.5127 52.7437C31.5642 52.6178 31.6318 52.5343 31.7109 52.4976L31.7139 52.4966C32.2951 52.1878 32.803 51.7899 33.165 51.4702C33.346 51.3104 33.4911 51.1696 33.5908 51.0688C33.6404 51.0187 33.6789 50.9786 33.7051 50.9507C33.7181 50.9368 33.7286 50.9258 33.7354 50.9185C33.7369 50.9168 33.739 50.9159 33.7402 50.9146C33.7447 50.9123 33.7485 50.9096 33.752 50.9077C33.7582 50.9043 33.7619 50.9017 33.7656 50.8999C33.7716 50.8971 33.7751 50.896 33.7803 50.896C33.787 50.896 33.795 50.8978 33.8027 50.9009L33.8184 50.9097L33.8174 50.9106L33.8262 50.9155L34.25 51.1831C34.2537 51.1893 34.2581 51.1979 34.2627 51.2065C34.2676 51.2158 34.2713 51.2252 34.2744 51.2329C34.2782 51.2424 34.2783 51.2441 34.2783 51.2407C34.2783 51.4413 34.2461 52.0363 34.0742 52.7603C33.9237 53.3938 33.6668 54.1242 33.2324 54.7749L33.0342 55.0483C32.8465 55.2159 32.6768 55.3041 32.5264 55.3345Z",
    fill: "#565656",
    stroke: "#6F6F6F",
    strokeWidth: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74707 55.3345C7.59625 55.3039 7.4265 55.2149 7.23828 55.0464C6.68308 54.333 6.37205 53.4838 6.2002 52.7603C6.02828 52.0363 5.99609 51.4414 5.99609 51.2407C5.99609 51.2441 5.99524 51.2424 5.99902 51.2329C6.00213 51.2251 6.00676 51.2159 6.01172 51.2065C6.01662 51.1973 6.0226 51.1885 6.02637 51.1821L6.44824 50.9165L6.45605 50.9097C6.45795 50.9079 6.46289 50.9041 6.4707 50.9009C6.47835 50.8978 6.48643 50.8961 6.49316 50.896C6.49838 50.896 6.50279 50.8971 6.50879 50.8999C6.51247 50.9017 6.51635 50.9044 6.52246 50.9077C6.52616 50.9097 6.53039 50.9121 6.53516 50.9146C6.53619 50.9157 6.5378 50.9171 6.53906 50.9185C6.5458 50.9258 6.55545 50.9369 6.56836 50.9507C6.59454 50.9786 6.63375 51.0185 6.68359 51.0688C6.78333 51.1697 6.92828 51.3103 7.10938 51.4702C7.4261 51.7499 7.8543 52.0892 8.3457 52.3765L8.56055 52.4966L8.5625 52.4976L8.62012 52.5337C8.67496 52.5784 8.72206 52.6492 8.76074 52.7437C8.81198 52.8688 8.84479 53.0305 8.8584 53.2134C8.88556 53.5792 8.83544 54.0217 8.71387 54.4097C8.59157 54.7998 8.40105 55.1238 8.15527 55.2671C8.03411 55.3377 7.8981 55.3649 7.74707 55.3345Z",
    fill: "#565656",
    stroke: "#6F6F6F",
    strokeWidth: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2874 5.87158L27.7105 5.87158C28.2598 5.87158 28.7051 5.45107 28.7051 4.93234V4.91873C28.7051 4.4 28.2598 3.9795 27.7105 3.9795L12.2874 3.9795C11.7381 3.9795 11.2928 4.4 11.2928 4.91873V4.93234C11.2928 5.45107 11.7381 5.87158 12.2874 5.87158Z",
    fill: "#E71F00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25422 4.33332C4.71289 4.33332 4.27406 4.74774 4.27406 5.25894C4.27406 5.77015 4.71289 6.18457 5.25422 6.18457C5.79555 6.18457 6.23438 5.77015 6.23438 5.25894C6.23438 4.74774 5.79555 4.33332 5.25422 4.33332Z",
    fill: "#E78E00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7308 4.33332C34.1895 4.33332 33.7506 4.74774 33.7506 5.25894C33.7506 5.77015 34.1895 6.18457 34.7308 6.18457C35.2721 6.18457 35.7109 5.77015 35.7109 5.25894C35.7109 4.74774 35.2721 4.33332 34.7308 4.33332Z",
    fill: "#E78E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_26643_10239",
    x: 3.01484,
    y: 6.60762,
    width: 36.6852,
    height: 61.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.35,
    result: "effect1_foregroundBlur_26643_10239"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_26643_10239",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8768 60.1769) rotate(-90) scale(2.15752 2.60174)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151921",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26643_10239",
    x1: 19.8763,
    y1: 59.4219,
    x2: 19.997,
    y2: 49.8082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26643_10239",
    x1: 1.60733,
    y1: 23.2678,
    x2: 44.8496,
    y2: 23.2678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#141818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#272727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26643_10239",
    x1: 19.9997,
    y1: 51.9214,
    x2: 19.9997,
    y2: 6.44322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A2A2A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26643_10239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.2857,
    height: 63.2692,
    fill: "white",
    transform: "matrix(-1 0 0 -1 37.6426 66.8267)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/Auto.c954c3420d3d97037ba47b8cf314ad40.svg";
export { ForwardRef as ReactComponent };